/* SVE Ingredient library: animal / goal / search filters, "show more" and the detail dialog. */
(function () {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var grid = root.querySelector('[data-grid]');
    var items = Array.prototype.slice.call(root.querySelectorAll('.sve-ingx__item'));
    items.sort(function (a, b) { return a.dataset.name.localeCompare(b.dataset.name); });
    items.forEach(function (li) { grid.appendChild(li); });
    var count = root.querySelector('[data-count]');
    var empty = root.querySelector('[data-empty]');
    var more = root.querySelector('[data-more]');
    var search = root.querySelector('[data-search]');
    var dialog = root.querySelector('[data-dialog]');
    var dialogBody = root.querySelector('[data-dialog-body]');
    var pageSize = parseInt(root.dataset.pageSize, 10) || 24;
    var params = new URLSearchParams(window.location.search);
    var state = { animal: params.get('animal') || 'all', goal: params.get('goal') || 'all', q: '', limit: pageSize };
    var lastTrigger = null;

    function setPressed(filter, value) {
      var btns = root.querySelectorAll('[data-filter="' + filter + '"]');
      var found = false;
      btns.forEach(function (b) { if (b.dataset.value === value) found = true; });
      if (!found) value = 'all';
      btns.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.value === value ? 'true' : 'false'); });
      state[filter] = value;
    }

    function apply() {
      var shown = 0;
      var matched = 0;
      items.forEach(function (li) {
        var ok = (state.animal === 'all' || (' ' + li.dataset.animals + ' ').indexOf(' ' + state.animal + ' ') > -1) &&
          (state.goal === 'all' || (',' + li.dataset.goals + ',').indexOf(',' + state.goal + ',') > -1) &&
          (!state.q || li.dataset.name.indexOf(state.q) > -1);
        if (ok) matched++;
        var visible = ok && (state.q || matched <= state.limit);
        li.hidden = !visible;
        if (visible) shown++;
      });
      if (count) count.textContent = (count.dataset.template || '{n}').replace('{n}', matched);
      if (empty) empty.hidden = matched !== 0;
      if (more) more.hidden = shown >= matched;
    }

    function syncUrl() {
      if (!window.history.replaceState) return;
      var p = new URLSearchParams(window.location.search);
      ['animal', 'goal'].forEach(function (k) { if (state[k] === 'all') p.delete(k); else p.set(k, state[k]); });
      var qs = p.toString();
      window.history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
    }

    root.addEventListener('click', function (e) {
      var f = e.target.closest('[data-filter]');
      if (f) {
        setPressed(f.dataset.filter, f.dataset.value);
        state.limit = pageSize;
        apply();
        syncUrl();
        return;
      }
      if (e.target.closest('[data-more]')) {
        state.limit += pageSize;
        apply();
        return;
      }
      var card = e.target.closest('[data-open]');
      if (card && dialog) {
        var detail = card.parentNode.querySelector('[data-detail]');
        if (!detail) return;
        dialogBody.innerHTML = detail.innerHTML;
        var title = dialogBody.querySelector('[data-title]');
        if (title) title.id = dialog.getAttribute('aria-labelledby');
        lastTrigger = card;
        if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', '');
        dialogBody.scrollTop = 0;
        return;
      }
      if (e.target.closest('[data-close]') || e.target === dialog) {
        dialog.close ? dialog.close() : dialog.removeAttribute('open');
      }
    });

    if (dialog) {
      dialog.addEventListener('close', function () {
        if (lastTrigger) lastTrigger.focus();
      });
    }

    if (search) {
      search.addEventListener('input', function () {
        state.q = search.value.trim().toLowerCase();
        apply();
      });
    }

    setPressed('animal', state.animal);
    setPressed('goal', state.goal);
    apply();
  }

  function boot() { document.querySelectorAll('[data-sve-ingx]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
